import { connect } from '@ardoq/rxbeach';
import { TertiaryButton } from '@ardoq/button';
import { Icon } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { viewpointToolBar$ } from './viewpointToolBar$';
import {
  isEnabledViewpointToolBar,
  ViewpointToolBarState,
} from './toViewpointToolBarProps';
import { ToolbarDivider } from '@ardoq/page-layout';
import { ViewpointToolbarContextDropdown } from 'canvas/contextToolBar/viewpointToolBar/ViewpointToolbarContextDropdown';
import { Text } from '@ardoq/typography';
import { DisabledToolbar } from 'canvas/contextToolBar/viewpointToolBar/DisabledToolbar';
import { SelectionToolbar } from './SelectionToolbar';
import { t } from '@ardoq/i18n';
import { ViewpointSelectorButton } from './ViewpointSelectorButton';
import { ShowExcludedButton } from './ShowExcludedButton';
import { tourAnchorIds } from '@ardoq/product-tours';

const ViewpointToolBarBase = (props: ViewpointToolBarState) => {
  const { i18nLocale } = props;
  if (!isEnabledViewpointToolBar(props)) {
    return (
      <DisabledToolbar
        excludedComponentCount={props.excludedComponentCount}
        i18nLocale={i18nLocale}
        isDiscover={props.isDiscover}
        datasetsButton={props.datasetsButton}
        viewpointsButton={props.viewpointButton}
        openInInventoryButton={props.openInInventoryButton}
        contextDropdownDisabledText={props.contextDropdownDisabledText}
      />
    );
  }
  const {
    contextDropdown,
    viewpointButton,
    priorityViewpointItems,
    seeAllViewpointsLabel,
    defaultOverviewLabel,
    datasetsButton,
    openInInventoryButton,
    isDiscover,
    excludedComponentCount,
  } = props;
  if (contextDropdown.currentContext.isGraphSelection) {
    return <SelectionToolbar {...props} />;
  }
  return (
    <FlexBox
      gap="medium"
      align="center"
      borderWidth={1}
      borderColor="transparent"
      padding="xsmall"
      data-tour-id={tourAnchorIds.canvasViewpointToolbar}
    >
      <FlexBox gap="xsmall" align="center">
        <ViewpointToolbarContextDropdown
          i18nLocale={i18nLocale}
          {...contextDropdown}
        />
      </FlexBox>
      <FlexBox gap="small" align="center">
        <Text color="textSubtle" variant="caption">
          {t(i18nLocale, 'canvas:contextToolbarViewpointLabel', 'Viewpoint')}
        </Text>
        <ViewpointSelectorButton
          viewpointButton={viewpointButton}
          priorityViewpointItems={priorityViewpointItems}
          seeAllViewpointsLabel={seeAllViewpointsLabel}
          defaultOverviewLabel={defaultOverviewLabel}
        />
      </FlexBox>
      <ShowExcludedButton
        excludedComponentCount={excludedComponentCount}
        isDiscover={isDiscover}
        i18nLocale={i18nLocale}
      />
      {!isDiscover && (
        <>
          <ToolbarDivider />
          <TertiaryButton
            onClick={datasetsButton.onClick}
            isActive={datasetsButton.isActive}
            buttonSize={datasetsButton.buttonSize}
            isDisabled={datasetsButton.isDisabled}
          >
            <Icon iconName={datasetsButton.iconName} />
            {datasetsButton.text}
          </TertiaryButton>
        </>
      )}
      {openInInventoryButton && (
        <>
          <ToolbarDivider />
          <TertiaryButton
            onClick={openInInventoryButton.onClick}
            isActive={openInInventoryButton.isActive}
            buttonSize={openInInventoryButton.buttonSize}
            isDisabled={openInInventoryButton.isDisabled}
          >
            <Icon iconName={openInInventoryButton.iconName} />
            {openInInventoryButton.text}
          </TertiaryButton>
        </>
      )}
    </FlexBox>
  );
};

export const ViewpointToolBar = connect(
  ViewpointToolBarBase,
  viewpointToolBar$
);
